(function() {
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (!drawerDetails) return;

  let historyPushed = false;

  // Observar cuando el menú se abre
  const observer = new MutationObserver(function() {
    const isOpen = drawerDetails.hasAttribute('open');

    if (isOpen && !historyPushed) {
      history.pushState({ menuOpen: true }, '');
      historyPushed = true;
    } else if (!isOpen) {
      historyPushed = false;
    }
  });

  observer.observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });

  // Interceptar el botón Back
  window.addEventListener('popstate', function() {
    if (drawerDetails.hasAttribute('open')) {
      const headerDrawer = drawerDetails.closest('header-drawer');
      if (headerDrawer && typeof headerDrawer.close === 'function') {
        // Usa el método nativo del componente — activa la animación completa
        headerDrawer.close();
      } else {
        // Fallback: simular click en el botón de cerrar
        const closeBtn = drawerDetails.querySelector('.menu-drawer__close-button');
        if (closeBtn) closeBtn.click();
      }
      historyPushed = false;
    }
  });
})();
